export default {
  scrollYPosition() {
    return window.pageYOffset || document.documentElement.scrollTop
  },

  slugParser(slug) {
    let match
    if ((match = slug.match(/theconversation.com\/.*-(\d+)$/))) {
      return match[1]
    }
    return null
  },
}
